import styled from '@emotion/styled';
import { Box } from './Box';
export const LinkBase = styled(Box.withComponent('a')) `
  cursor: pointer;
`;
LinkBase.defaultProps = {
    palette: 'primary',
};

//# sourceMappingURL=LinkBase.js.map
